import React from 'react';
import ViewChart from '@/screens/Timeline/components/ViewChart';
import dayjs from 'dayjs';
import constants from '@/constants';
import emrTypeHelper from '@/helper/emrType';

type Props = {
  emrType: any;
  data: any;
};
const HealthRecordChart = ({ emrType, data }: Props) => {
  const [pointIndex] = React.useState<number>(0);

  return (
    <div className="mb-4 rounded-lg w-full h-full pt-2">
      <ViewChart
        title={`Biểu đồ ${emrType?.name}`}
        times={data ? data?.map((d: any) => (d.date ? dayjs(d.date).format(constants.DATE_TIME_FORMAT) : '')) : []}
        pointIndex={pointIndex}
        series={emrType?.extra.formDetail?.chartConfigFn?.(data, emrType, emrTypeHelper.toFixByKeyConfig)}
      />
    </div>
  );
};

export default HealthRecordChart;
